import {connect} from "react-redux";
import {setReportHardCopy} from "../../../../actions/action";
import {getggLabTestListAction} from "../../../../actions";
import AdditionalServices from '../component/AdditionalServices';
import { Toaster, Intent, Position } from '@blueprintjs/core';


const mapStateToProps = state =>{

    return{
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        setReportHardCopy : (obj) =>{
            return setReportHardCopy(obj)
                .catch((error) => {
                    if (error.response && error.response.status !== 401) {
                        Object.keys(error.response.data.error).forEach((key) => {
                            error.response.data.error[key].forEach((error) => {
                                Toaster.create({position: Position.TOP}).show({
                                    message: error,
                                    intent: Intent.DANGER
                                });
                            });
                        });
                    }
                });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalServices)